export const androidOraVersion = 240;

export const windowsOraVersion = {
  development: 2101,
  testing: 2002,
  staging: 2002,
  production: 2100
};
